(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFileTypesController', TabFileTypesController);

    TabFileTypesController.$inject = ['$scope', '$state', 'TabFileTypes', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'paginationConstants'];

    function TabFileTypesController($scope, $state, TabFileTypes, ParseLinks, AlertService, DataUtils, pagingParams, paginationConstants) {
        var vm = this;
        //vm.predicates = {};
        vm.tabFileTypes = [];
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.currentState = "tab-file-types";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }


        vm.loadAll = function () {
            // new variable search, which have the filtering string
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                search: vm.charToSearch,
                sort: sort()
            };

            TabFileTypes.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabFileTypes = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabFileTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function () {
            vm.page = 0;
            vm.tabFileTypes = [];
            var orderCall = vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        // added the function search , to reload the page after a filter has been detected (string in the search bar)
        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };


        vm.loadAll();

    }
})();
